// src/i18n/ecrContent.ts
export type EcrLang = "en" | "fr" | "pt";

export type EcrCopy = {
  title: string;
  call: string;
  intro: string;
  backgroundTitle: string;
  backgroudFirst?: any;
  background: string[];
  objectivesTitle: string;
  objectivesLead: string;
  objectives: string[];
  whoTitle: string;
  whoLead: string;
  who: string[];
  whoTail?: string;
  benefitsTitle: string;
  benefitsLead: string;
  benefits: string[];
  howTitle: string;
  howLead?: string;
  eoiUrl: string;
  provideTitle: string;
  provide: string[];
  deadline: string;
  contact?: string;
  deadlineDate?: string;
  closing: string;
};

export const ECR_CONTENT: Record<EcrLang, EcrCopy> = {
  en: {
    title: "LIBSENSE ECR Network Expansion",
    call: "Call for Participation",
    intro:`<p>LIBSENSE is expanding its <a target="_blank" href="/ecr">Early Career Researchers (ECR) Network</a> and therefore invites interested researchers and librarians to join its growing ECR Network. This initiative aims to foster a vibrant, interdisciplinary community of early-career scholars who actively shape the future of research through collaboration, advocacy, and open science practices. By joining, you will be part of a network that offers significant growth potential and the opportunity to shape the future of research in Africa.</p>`,
    backgroundTitle: "Background",
    backgroudFirst: `<p>The ECR Programme emerged as part of LIBSENSE's mission to embed community-led, bottom-up approaches into the development of research and education systems on the continent. Beginning in <a href="/ecr-nigeria" target="_blank" >Nigeria</a> and <a href="/ecr-ghana" target="_blank">Ghana</a>, the programme has already mobilised a national team of librarians and researchers to support data management, open access, research ethics, and scholarly communication reforms in their respective academic environments.
    </p>`,
    background: [
      
      "With this call, LIBSENSE seeks to expand the ECR community across institutions in Africa, fostering inclusivity, equity, regional collaboration and capacity building for open science. We value diversity and are committed to creating an inclusive and equitable environment for all our members.",
    ],
    objectivesTitle: "Objectives",
    objectivesLead: "The LIBSENSE ECR Network seeks to:",
    objectives: [
      "Empower members with tools, knowledge, and peer support to practice open science.",
      "Promote interdisciplinary collaboration and regional partnerships across African institutions.",
      "support the adoption of open science principles, including FAIR data, open access, and research transparency.",
      "Enhance the visibility and impact of African research outputs.",
      "Provide a platform for ECRs to engage in leadership, advocacy, and knowledge exchange.",
      "Foster open science communities on campus"
    ],
    whoTitle: "Who Should Apply",
    whoLead: "We welcome applications from individuals who:",
    who: [
      "are Early Career Researchers (within 1–10 years of academic or professional research experience).",
      "are based at a university or research institution in any country in Africa",
      "demonstrate basic understanding of open science (e.g., open access, research data management, research ethics).",
      "are committed to participating in community activities, sharing our knowledge, and contributing to the growth of the network.",
    ],
    whoTail:
      "We also encourage participation from students, librarians, and research support staff who have a strong interest in open science and want to contribute as volunteers or mentors.",
    benefitsTitle: "Benefits of Joining",
    benefitsLead: "Participants in the LIBSENSE ECR Network will gain:",
    benefits: [
      "increased visibility through LIBSENSE activities, blogs, and joint publications.",
      "access to a regional and pan-African community of open science practitioners.",
      "opportunities to participate in workshops, webinars, and collaborative research initiatives.",
      "training in open science tools and practices (e.g., data repositories, open publishing platforms).",
      "mentorship and leadership development within an inclusive, peer-led environment.",
    ],
    howTitle: "How to Apply",
    howLead:
      "Interested individuals should complete the Expression of Interest (EOI)",
    eoiUrl:
      "https://survey.wacren.net/index.php/184311?lang=en",
    provideTitle: "You will be asked to provide:",
    provide: [
      "A brief description of your background and institution",
      "Evidence of interest or engagement in open science (e.g., events, advocacy, projects, publications)",
      "Your motivation for joining and how you plan to contribute to the ECR Network",
    ],
    deadline: "Deadline for submission:",
    deadlineDate: "Friday, October 31, 2025",

    // contact: "For inquiries, please contact: libsense@ren.africa",
    closing:
      "Join us in shaping a collaborative, community-led movement for open and responsible research across Africa!",
  },

  fr: {
    title:
      "Expansion du Réseau LIBSENSE ECR",
    call: "Appel à Participation",
    intro:
      `<p>LIBSENSE renforce son <a target="_blank" href="/ecr">Réseau de Chercheurs en Début de Carrière (ECR)</a> et invite donc les chercheurs et bibliothécaires intéressés à rejoindre ce réseau en pleine croissance. Cette initiative vise à favoriser une communauté dynamique et interdisciplinaire de jeunes chercheurs qui façonnent activement l’avenir de la recherche grâce à la collaboration, au plaidoyer et aux pratiques de la science ouverte. En rejoignant ce réseau, vous ferez partie d’une communauté offrant un fort potentiel de développement et l’opportunité d’influencer l’avenir de la recherche dans notre région.</p>`,
    backgroundTitle: "Contexte",
    background: [
      "Le programme ECR est né dans le cadre de la mission de LIBSENSE, qui vise à intégrer des approches communautaires et ascendantes dans le développement des systèmes de recherche et d’éducation sur le continent. Lancé au Nigéria et au Ghana, le programme a déjà mobilisé une équipe nationale de bibliothécaires et de chercheurs pour soutenir la gestion des données, l’accès ouvert, l’éthique de la recherche et les réformes de la communication scientifique dans leurs environnements académiques respectifs. En savoir plus sur le programme ici : https://libsense.ren.africa/ecr",
      "Avec cet appel, LIBSENSE souhaite étendre la communauté ECR aux institutions d’Afrique, en favorisant l’inclusion, l’équité, la collaboration régionale et le renforcement des capacités pour la science ouverte. Nous valorisons la diversité et nous engageons à créer un environnement inclusif et équitable pour tous nos membres.",
    ],
    objectivesTitle: "Objectifs",
    objectivesLead: "Le Réseau ECR de LIBSENSE vise à :",
    objectives: [
      "Fournir à ses membres des outils, connaissances et un soutien par les pairs pour pratiquer la science ouverte, avec un engagement à leur fournir les ressources nécessaires pour réussir en tant que chercheur en début de carrière.",
      "Promouvoir la collaboration interdisciplinaire et les partenariats régionaux entre institutions en Afrique.",
      "Soutenir l’adoption des principes de la science ouverte, notamment les données FAIR, l’accès ouvert et la transparence de la recherche.",
      "Accroître la visibilité et l’impact des résultats de la recherche africaine.",
      "Offrir une plateforme aux ECR pour exercer des rôles de leadership, de plaidoyer et d’échange de connaissances.",
    ],
    whoTitle: "Qui peut postuler ?",
    whoLead: "Nous accueillons les candidatures de personnes qui :",
    who: [
      "Sont des chercheurs en début de carrière (entre 1 et 10 ans d’expérience académique ou professionnelle en recherche).",
      "Sont basées dans une université ou un institut de recherche dans un pays d’Afrique.",
      "Ont une compréhension de base de la science ouverte (par ex. : accès ouvert, gestion des données de recherche, éthique de la recherche).",
      "S’engagent à participer aux activités communautaires, partager leurs connaissances et contribuer à la croissance du réseau.",
    ],
    whoTail:
      "Nous encourageons également la participation des étudiants, bibliothécaires et personnels de soutien à la recherche ayant un vif intérêt pour la science ouverte et souhaitant contribuer comme bénévoles ou mentors.",
    benefitsTitle: "Avantages",
    benefitsLead:
      "Les participants au Réseau ECR de LIBSENSE bénéficieront :",
    benefits: [
      "D’un accès à une communauté régionale et panafricaine de praticiens de la science ouverte.",
      "D’opportunités de participer à des ateliers, webinaires et projets de recherche collaborative.",
      "De formations aux outils et pratiques de la science ouverte (ex. : dépôts de données, plateformes de publication ouverte).",
      "De mentorat et développement du leadership dans un environnement inclusif dirigé par les pairs.",
      "D’une meilleure visibilité grâce aux activités de LIBSENSE, blogs et publications conjointes.",
    ],
    howTitle: "Comment postuler",
    howLead:
      "Les personnes intéressées doivent remplir le formulaire de manifestation d’intérêt (EOI) disponible ici :",
    eoiUrl: "https://survey.wacren.net/index.php/255586?lang=fr",
    provideTitle: "Vous devrez fournir :",
    provide: [
      "Une brève description de votre parcours et de votre institution",
      "Des preuves d’intérêt ou d’engagement dans la science ouverte (ex. : événements, plaidoyers, projets, publications)",
      "Votre motivation à rejoindre et comment vous prévoyez de contribuer au Réseau ECR",
    ],
    deadline:
      "Date limite de soumission: ",
      deadlineDate: "Vendredi 31 octobre 2025",
    // contact: "Pour toute question, contactez : libsense@ren.africa",
    closing:
      "Rejoignez-nous pour façonner un mouvement collaboratif et communautaire pour une recherche ouverte et responsable en Afrique !",
  },

  pt: {
    title:
      "Expansão da Rede LIBSENSE ECR",
    call: "Convite à Participação",
    intro:
      `<p>A LIBSENSE  está expandindo sua <a target="_blank" href="/ecr">Rede de Pesquisadores em Início de Carreira (ECR)</a> e convida pesquisadores e bibliotecários interessados a juntar-se a esta rede em crescimento. Esta iniciativa visa promover uma comunidade interdisciplinar vibrante de jovens pesquisadores que moldam ativamente o futuro da pesquisa por meio da colaboração, do advocacy e das práticas de ciência aberta. Ao se juntar, você fará parte de uma rede que oferece grande potencial de crescimento e a oportunidade de influenciar o futuro da pesquisa em nossa região.</p>`,
    backgroundTitle: "Contexto",
    background: [
      "O Programa ECR surgiu como parte da missão da LIBSENSE de incorporar abordagens comunitárias e ascendentes no desenvolvimento dos sistemas de pesquisa e educação no continente. Iniciado na Nigéria e em Gana, o programa já mobilizou uma equipe nacional de bibliotecários e pesquisadores para apoiar a gestão de dados, o acesso aberto, a ética em pesquisa e as reformas na comunicação científica em seus respectivos ambientes acadêmicos. Saiba mais sobre o programa aqui: https://libsense.ren.africa/ecr.",
      "Com este convite, a LIBSENSE busca expandir a comunidade ECR em instituições da Região WACREN, promovendo inclusão, equidade, colaboração regional e desenvolvimento de capacidades para a ciência aberta. Valorizamos a diversidade e estamos comprometidos em criar um ambiente inclusivo e equitativo para todos os nossos membros.",
    ],
    objectivesTitle: "Objetivos",
    objectivesLead: "A Rede ECR da LIBSENSE busca:",
    objectives: [
      "Capacitar seus membros com ferramentas, conhecimento e apoio de pares para praticar ciência aberta, oferecendo recursos necessários para o sucesso nessa área.",
      "Promover a colaboração interdisciplinar e parcerias regionais entre instituições da África Ocidental.",
      "Apoiar a adoção dos princípios da ciência aberta, incluindo dados FAIR, acesso aberto e transparência na pesquisa.",
      "Ampliar a visibilidade e o impacto dos resultados de pesquisa africanos.",
      "Oferecer uma plataforma para que os ECRs exerçam liderança, advocacy e intercâmbio de conhecimento.",
    ],
    whoTitle: "Quem pode se inscrever",
    whoLead: "Recebemos inscrições de pessoas que:",
    who: [
      "São pesquisadores em início de carreira (com entre 1 e 10 anos de experiência acadêmica ou profissional em pesquisa).",
      "Estão vinculadas a uma universidade ou instituição de pesquisa em qualquer país da África.",
      "Possuem compreensão básica de ciência aberta (por exemplo: acesso aberto, gestão de dados de pesquisa, ética em pesquisa).",
      "Comprometem-se a participar de atividades comunitárias, compartilhar conhecimento e contribuir para o crescimento da rede.",
    ],
    whoTail:
      "Também incentivamos a participação de estudantes, bibliotecários e profissionais de apoio à pesquisa que tenham forte interesse em ciência aberta e desejem contribuir como voluntários ou mentores.",
    benefitsTitle: "Benefícios",
    benefitsLead:
      "Os participantes da Rede ECR da LIBSENSE terão acesso a:",
    benefits: [
      "Uma comunidade regional e panafricana de praticantes de ciência aberta.",
      "Oportunidades para participar de workshops, webinars e iniciativas de pesquisa colaborativa.",
      "Treinamento em ferramentas e práticas de ciência aberta (ex.: repositórios de dados, plataformas de publicação aberta).",
      "Mentoria e desenvolvimento de liderança em um ambiente inclusivo e conduzido por pares.",
      "Maior visibilidade por meio das atividades da LIBSENSE, blogs e publicações conjuntas.",
    ],
    howTitle: "Como se inscrever",
    howLead:
      "Os interessados devem preencher o formulário de Manifestação de Interesse (EOI) disponível em:",
    eoiUrl: "https://survey.wacren.net/index.php/291677?lang=pt",
    provideTitle: "Você deverá fornecer:",
    provide: [
      "Uma breve descrição do seu histórico e instituição",
      "Evidências de interesse ou engajamento em ciência aberta (ex.: eventos, advocacy, projetos, publicações)",
      "Sua motivação para participar e como pretende contribuir para a Rede ECR",
    ],
    deadline:
      "Prazo para inscrição:",
      deadlineDate: "Sexta-feira, 31 de outubro de 2025",
    // contact: "Para mais informações, entre em contato: libsense@ren.africa",
    closing:
      "Junte-se a nós para construir um movimento colaborativo e comunitário para uma pesquisa aberta e responsável na África Ocidental!",
  },
};

